import { createContext, useContext } from "react";

interface LayoutContextProps {
  headerButtons: Record<string, React.ReactNode>;
  addHeaderButton: (key: string, button: React.ReactNode) => void;
  hideWidgets: boolean;
  messengerBottomOffset: number;
  setMessengerBottomOffset: (offset: number) => void;
  messengerCompactEdge: number;
  setMessengerCompactEdge: (edge: number) => void;
}

export const LayoutContext = createContext<LayoutContextProps | undefined>(
  undefined,
);

export const useLayoutContext = (): LayoutContextProps => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error("useLayoutContext must be used within a LayoutProvider");
  }
  return context;
};
